/* unplugin-vue-components disabled */import script from "./WxPayBaseConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./WxPayBaseConfig.vue?vue&type=script&setup=true&lang=ts"

import "./WxPayBaseConfig.vue?vue&type=style&index=0&id=4fa4d548&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa4d548"]])

export default __exports__